import { useEffect, useRef } from "react";

const WeatherWidgetDotOrgWeatherWidget = ({ selectedFleet, "data-testid": dataTestId = "weather-widget-dot-org" }) => {
  const widgetId = selectedFleet?.weatherWidgetId || "wl0000";
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    // Clear previous widget content
    widgetRef.current.innerHTML = "";

    // Inject new widget markup
    widgetRef.current.innerHTML = `
      <div 
        id="ww_cd009527a11b0"
        v="1.3"
        loc="id"
        a='${JSON.stringify({
          t: "responsive",
          lang: "en",
          sl_lpl: 1,
          ids: [widgetId],
          font: "Arial",
          sl_ics: "one_a",
          sl_sot: "fahrenheit",
          cl_bkg: "image",
          cl_font: "#FFFFFF",
          cl_cloud: "#FFFFFF",
          cl_persp: "#81D4FA",
          cl_sun: "#FFC107",
          cl_moon: "#FFC107",
          cl_thund: "#FF5722",
        })}'
      >
        More forecasts:
        <a 
          href="https://oneweather.org/new_york_city/30_days/"
          id="ww_cd009527a11b0_u"
          target="_blank"
          rel="noreferrer"
        >
          oneweather.org/new_york_city/30_days/
        </a>
      </div>
    `;

    // Re-inject widget script
    const script = document.createElement("script");
    script.src = "https://app3.weatherwidget.org/js/?id=ww_cd009527a11b0";
    script.async = true;

    widgetRef.current.appendChild(script);
  }, [widgetId]);

  return <div key={widgetId} ref={widgetRef} data-testid={dataTestId} />;
};

export default WeatherWidgetDotOrgWeatherWidget;

